<template>
  <div class="vtooltip relative">
    <div
      v-if="!shouldHide"
      class="vtooltip-positioner absolute pointer-events-none w-fit"
      :class="[direction, { [`hidden ${hideOnBreakpoint}_block`]: hideOnBreakpoint }]"
    >
      <div
        class="vtooltip-content relative px-3 py-2 text-sm text-center text-gray-100 rounded-md opacity-0 bg-gray-800 transition-opacity delay-75 duration-500 shadow-md w-fit"
      >
        <slot name="content" />
      </div>
    </div>

    <slot />
  </div>
</template>

<script lang="ts" setup>
// TODO: Add other directions as needed
export type TooltipDirection = 'right' | 'left' | 'top' | 'top-right' | 'top-left' | 'bottom'

defineProps({
  shouldHide: {
    type: [Boolean, String],
    default: false,
  },
  direction: {
    type: String as PropType<TooltipDirection>,
    default: 'right',
  },
  hideOnBreakpoint: {
    type: String,
    default: null,
  },
})
</script>

<style lang="stylus" scoped>
.vtooltip
  &:hover .vtooltip-content
    @apply delay-1000
    opacity: 1

  .vtooltip-positioner
    top auto
    bottom 100%

    @screen sm
      &.top
        @apply bottom-full mb-4
        left 50%

        .vtooltip-content
          transform translateX(-50%)
          &::after
            top 100%
            transform translate(-50%, -50%) rotate(45deg)

      &.top-right
        @apply left-full bottom-full mb-4
        margin-left: var(--marginLeft, -2rem)

        .vtooltip-content::after
          top 100%
          left 13px
          transform rotate(45deg) translate(-50%, -50%)

      &.top-left
        @apply right-0 bottom-full mb-4

        .vtooltip-content::after
          top 100%
          right 0.25rem
          transform rotate(45deg) translate(-50%, -50%)

      &.right
        @apply left-full ml-4
        top 50%

        .vtooltip-content
          transform translateY(-50%)
          &::after
            top 50%
            left -13px
            transform rotate(135deg) translateX(-50%)

      &.left
        @apply right-full mr-4
        top 50%

        .vtooltip-content
          transform translateY(-50%)
          &::after
            top 50%
            right -12px
            transform rotate(-45deg) translateY(-50%)

      &.bottom
        @apply top-full mt-4
        left 50%

        .vtooltip-content
          transform translateX(-50%)
          &::after
            bottom 100%
            transform translate(-50%, -50%) rotate(225deg)

      .vtooltip-content::after
        background-color: inherit
        border-radius: 16px 0 4px 0
        clip-path polygon(0 100%, 100% 0, 100% 100%)
        border 0
        content ""
        position absolute
        width 16px
        height 16px
        top 0
</style>
